import { Dispatch, SetStateAction, createContext, useContext } from "react";

export interface TaskPageContextValue {
	searchInput: string;
	setSearchInput: Dispatch<SetStateAction<string>>;
	selectedGroupIds: number[];
	setSelectedGroupIds: Dispatch<SetStateAction<number[]>>;
	completedDateFrom: string;
	setCompletedDateFrom: Dispatch<SetStateAction<string>>;
	completedDateTo: string;
	setCompletedDateTo: Dispatch<SetStateAction<string>>;
	completedOnlyHandover: boolean;
	setCompletedOnlyHandover: Dispatch<SetStateAction<boolean>>;
	completedOnlyShiftlog: boolean;
	setCompletedOnlyShiftlog: Dispatch<SetStateAction<boolean>>;
}

const TaskPageContext = createContext<TaskPageContextValue | null>(null);

export const TaskPageContextProvider = TaskPageContext.Provider;

export function useTaskPage() {
	return useContext(TaskPageContext);
}
